import {createSlice} from "@reduxjs/toolkit";
import EventBus from "../../../eventbus/EventBus";
import {
    CURRENCY_ACTIVATE_FAILED,
    CURRENCY_ACTIVATE_REQUESTED,
    CURRENCY_ACTIVATE_SUCCESS,
    CURRENCY_CONVERTER_CONVERT_FAILED,
    CURRENCY_CONVERTER_CONVERT_REQUESTED,
    CURRENCY_CONVERTER_CONVERT_SUCCESS,
    CURRENCY_DEACTIVATE_FAILED,
    CURRENCY_DEACTIVATE_REQUESTED,
    CURRENCY_DEACTIVATE_SUCCESS,
    CURRENCY_GET_FAILED,
    CURRENCY_GET_REQUESTED,
    CURRENCY_GET_SUCCESS,
    CURRENCY_UPDATE_RATE_FAILED,
    CURRENCY_UPDATE_RATE_REQUESTED,
    CURRENCY_UPDATE_RATE_SUCCESS
} from "../../../eventbus/currency/currencyEvents";
import currencyService from "../../services/currency/currencyService";


export const CURRENCY_INITIALIZATION_STATE_NOT_STARTED = 0
export const CURRENCY_INITIALIZATION_STATE_LOADING = 1
export const CURRENCY_INITIALIZATION_STATE_COMPLETE = 2

const currencySlice = createSlice({
    name: 'currency',
    initialState: {
        currencies: [],
        currencyInitializationState: CURRENCY_INITIALIZATION_STATE_NOT_STARTED,
    },
    reducers: {
        setCurrencies: (state, action) => {
            state.currencies = action.payload
        },
        setCurrencyInitializationState: (state, action) => {
            state.currencyInitializationState = action.payload
        },
    }
})


export const currencyGetAsync = () => (dispatch) => {
    const params = {}

    EventBus.dispatch(CURRENCY_GET_REQUESTED)
    dispatch(currencySlice.actions.setCurrencyInitializationState(CURRENCY_INITIALIZATION_STATE_LOADING));
    return new Promise(() => {
        currencyService.currencyGet(params)
            .then(response => {
                dispatch(currencySlice.actions.setCurrencies(response.data))
                EventBus.dispatch(CURRENCY_GET_SUCCESS, response.data)
            })
            .catch(error => {
                EventBus.dispatch(CURRENCY_GET_FAILED, error.response)
            })
            .finally(() => {
                dispatch(currencySlice.actions.setCurrencyInitializationState(CURRENCY_INITIALIZATION_STATE_COMPLETE));
            })
    })
}

export const currencyUpdateRate = ({id, rate}) => {
    EventBus.dispatch(CURRENCY_UPDATE_RATE_REQUESTED)
    return new Promise((resolve, reject) => {
        currencyService.currencyUpdateRate({id, rate})
            .then(response => {
                EventBus.dispatch(CURRENCY_UPDATE_RATE_SUCCESS, response.data)
                resolve()
            })
            .catch(error => {
                EventBus.dispatch(CURRENCY_UPDATE_RATE_FAILED, error.response)
                reject()
            })
    })
}

export const currencyActivateAsync = ({id}) => {
    EventBus.dispatch(CURRENCY_ACTIVATE_REQUESTED)
    return new Promise(() => {
        currencyService.currencyActivate({id})
            .then(response => {
                EventBus.dispatch(CURRENCY_ACTIVATE_SUCCESS, response.data)
            })
            .catch(error => {
                EventBus.dispatch(CURRENCY_ACTIVATE_FAILED, error.response)
            })
    })
}

export const currencyDeactivate = ({id}) => {
    EventBus.dispatch(CURRENCY_DEACTIVATE_REQUESTED)
    return new Promise(() => {
        currencyService.currencyDeactivate({id})
            .then(response => {
                EventBus.dispatch(CURRENCY_DEACTIVATE_SUCCESS, response)
            })
            .catch(error => {
                EventBus.dispatch(CURRENCY_DEACTIVATE_FAILED, error.response)
            })
    })
}

export const currencyConverterConvert = (payload) => {
    EventBus.dispatch(CURRENCY_CONVERTER_CONVERT_REQUESTED)

    return new Promise((resolve, reject) => {
        currencyService.currencyConverter(payload)
            .then(response => {
                resolve(response.data)
                EventBus.dispatch(CURRENCY_CONVERTER_CONVERT_SUCCESS, response.data)
            })
            .catch(error => {
                reject(error.response)
                EventBus.dispatch(CURRENCY_CONVERTER_CONVERT_FAILED, error.response)
            })
    })
}

export const selectCurrency = state => state.currency.currencies;
export const selectNationalCurrency = state => state.currency.currencies.find(c => c.is_national);
export const selectCurrencyInitializationState = state => state.currency.currencyInitializationState;

export default currencySlice.reducer
